"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelCall = cancelCall;
exports.checkInvoice = checkInvoice;
exports.createFollowUpEpl = createFollowUpEpl;
exports.createInvoice = createInvoice;
exports["default"] = void 0;
exports.deleteFile = deleteFile;
exports.getCallByEplId = getCallByEplId;
exports.getCallsByEplIds = getCallsByEplIds;
exports.getCorrespondenceById = getCorrespondenceById;
exports.getProject = getProject;
exports.getWorkstream = getWorkstream;
exports.loadCorrespondence = loadCorrespondence;
exports.provideAvailabilities = provideAvailabilities;
exports.rejectExpert = rejectExpert;
exports.reply = reply;
exports.submitExpert = submitExpert;
exports.updateInvoiceStatus = updateInvoiceStatus;
exports.upload = upload;

var _api = require("./api");

var _axios = _interopRequireDefault(require("axios"));

var _tokenStorage = _interopRequireDefault(require("./lib/tokenStorage"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// @ts-nocheck
var SIXTY_SECONDS = 60000;

var axiosInstance = _axios["default"].create({
  timeout: SIXTY_SECONDS,
  baseURL: process.env.REACT_APP_CAPI_SERVICE_URL,
  responseType: 'json'
});

axiosInstance.interceptors.request.use(function (request) {
  request.headers.Authorization = _tokenStorage["default"].get();
  return request;
});
axiosInstance.interceptors.response.use(function (response) {
  if (response.data === undefined) return response;
  return response.data;
}, function (error) {
  return Promise.reject(error);
});

function getProject(projectId) {
  return axiosInstance({
    method: 'get',
    url: "/check?p=".concat(projectId)
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getWorkstream(segmentId) {
  return axiosInstance({
    method: 'get',
    url: "/check?w=".concat(segmentId)
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getCallsByEplIds(eplIds) {
  return axiosInstance({
    method: 'post',
    url: "/calls/by/epl-ids",
    data: eplIds
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getCallByEplId(eplId) {
  return axiosInstance({
    method: 'get',
    url: "/calls/by/epl/".concat(eplId)
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function createFollowUpEpl(eplId, deliveredByEmployeeId) {
  return axiosInstance({
    method: 'post',
    url: "/calls/follow-up",
    data: {
      eplId: eplId,
      deliveredByEmployeeId: deliveredByEmployeeId
    }
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function cancelCall(eplId) {
  var cancelledFromPlatform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return axiosInstance({
    method: 'POST',
    url: "/calls/cancel",
    data: {
      eplId: eplId,
      cancelledFromPlatform: cancelledFromPlatform
    }
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function rejectExpert(data) {
  return axiosInstance({
    method: 'post',
    url: "/experts/reject",
    data: data
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function submitExpert(data) {
  return axiosInstance({
    method: 'post',
    url: "/submit",
    data: data
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function provideAvailabilities(data) {
  return axiosInstance({
    method: 'post',
    url: "/calls/availability/provide",
    data: data
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function createInvoice(data) {
  return axiosInstance({
    method: 'post',
    url: "/create-platform-invoice",
    data: data
  })["catch"](_api.errorHandler);
}

function checkInvoice(data) {
  return axiosInstance({
    method: 'post',
    url: "/invoice/check",
    data: data
  }).then(_api.extractData)["catch"](function (error) {
    if (error.message === 'Request failed with status code 404') {
      console.error({
        error: error
      });
      return;
    }

    (0, _api.errorHandler)(error);
  });
}

function updateInvoiceStatus(data) {
  return axiosInstance({
    method: 'post',
    url: "/invoice/update-status",
    data: data
  })["catch"](_api.errorHandler);
}

function reply(data) {
  return axiosInstance({
    method: 'post',
    url: "/reply",
    data: data
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function upload(data) {
  return axiosInstance({
    method: 'post',
    url: "/upload",
    data: data
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function loadCorrespondence(_ref) {
  var projectId = _ref.projectId,
      limit = _ref.limit,
      offset = _ref.offset;
  return axiosInstance({
    method: 'get',
    url: "/correspondence?p=".concat(projectId, "&offset=").concat(offset, "&limit=").concat(limit)
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function getCorrespondenceById(id, type) {
  return axiosInstance({
    method: 'get',
    url: "/correspondenceDetails?id=".concat(id, "&type=").concat(type)
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

function deleteFile(id) {
  return axiosInstance({
    method: 'get',
    url: "/deleteFile?f=".concat(id)
  }).then(_api.extractData)["catch"](_api.errorHandler);
}

var capi = {
  getProject: getProject,
  getWorkstream: getWorkstream,
  getCallsByEplIds: getCallsByEplIds,
  getCallByEplId: getCallByEplId,
  submitExpert: submitExpert,
  rejectExpert: rejectExpert,
  cancelCall: cancelCall,
  createFollowUpEpl: createFollowUpEpl,
  provideAvailabilities: provideAvailabilities,
  createInvoice: createInvoice,
  checkInvoice: checkInvoice,
  updateInvoiceStatus: updateInvoiceStatus,
  reply: reply,
  deleteFile: deleteFile,
  loadCorrespondence: loadCorrespondence,
  upload: upload,
  getCorrespondenceById: getCorrespondenceById
};
var _default = capi;
exports["default"] = _default;